import React, { useEffect, useRef, useState } from "react";

import "../styles/MainPageLayout.css"
import Header from "../components/Header";
import ListGroup from "../components/ListGroup";
import TeamsManagement from "../components/TeamsManagement";
import AddMemberPopUp from "../components/AddMemberPopup";
import CreateGroupPopup from "../components/CreateGroupPopup";
import { ImSpinner9 } from "react-icons/im";
import SSOService from "../services/SSOService";
import UserService from "../services/UserService";
import { APIStatus } from "../constants/constant";
import TeamService from "../services/TeamService";
import { useMsal } from "@azure/msal-react";
import ErrorPage from "./ErrorPage";
import axios from "axios";

export const MainPageLayout = () => {
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [isLoadingTeamInfo, setIsLoadingTeamInfo] = useState(true);
  const [isLoadingMemberList, setIsLoadingMemberList] = useState(false);
  const [isLoadingMoreMember, setIsLoadingMoreMember] = useState(false);

  const [isOpened, setIsOpened] = useState(false);
  const [isPopup, setIsPopup] = useState({ creatingGroup: false, addingMember: false })


  const [nextPageUrl, setNextPageUrl] = useState(null)
  const [idTeam, setIdTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState({
    owners: [],
    members: [],
  })
  const [isDisplayed, setIsDisplayed] = useState({
    owners: false,
    members: false,
  })
  const [currentTeamMembers, setCurrentTeamMembers] = useState({
    owners: [],
    members: [],
  })
  const [teamInfo, setTeamInfo] = useState({});
  const [apiError, setApiError] = useState(false);
  const [isErrorFetching, setIsErrorFetching] = useState(false);

  const { getSSO } = SSOService();
  const { getUserInfo } = UserService();
  const { getTeamMembers, getTeamInfo } = TeamService();

  const [userInfo, setUserInfo] = useState({});
  const [isOwner, setIsOwner] = useState(false);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const fetchSSO = async () => {
    try {
      const responseSSO = await getSSO();
      if (responseSSO.status !== APIStatus.success) {
        console.error(responseSSO);
      } else {
        const responseInfo = await getUserInfo();
        if (responseInfo.status === APIStatus.success)
          setUserInfo(responseInfo.data);
        else {
          console.error(responseInfo.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoadingUser(false)
    }
  }

  const fetchTeamInfo = async (id, signal) => {
    try {
      const response = await getTeamInfo(id, signal);
      if (response.status === APIStatus.success) {
        const info = response.data;
        setTeamInfo(info);
        setTeamMembers(prev => ({
          ...prev,
          owners: info.owners || [],
        }));
        setCurrentTeamMembers(prev => ({
          ...prev,
          owners: info.owners || [],
        }));
        setIsDisplayed(prev => ({
          ...prev,
          owners: info.owners.length > 0,
        }));
        let owner = info.owners.some(member => member.userId === account?.localAccountId)
        setIsOwner(owner)
      }
      else {
        console.error(response.data);
        setIsErrorFetching(true);
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      }
      else {
        setIsErrorFetching(true);
        console.error("Error fetching data: ", error);
      }
    }
  }

  const fetchTeamMembers = async (id, nextPageUrl, isLoadMore = false, signal) => {
    isLoadMore ? setIsLoadingMoreMember(true) : setIsLoadingMemberList(true);
    try {
      const response = await getTeamMembers(id, nextPageUrl, signal);
      if (response.status === APIStatus.success) {
        const members = response.data.members.filter(user => !user.isOwner);
        if (isLoadMore) {
          // Append members
          setTeamMembers(prev => ({
            ...prev,
            members: [...prev.members, ...members],
          }));
          setCurrentTeamMembers(prev => ({
            ...prev,
            members: [...prev.members, ...members],
          }));
        } else {
          setTeamMembers(prev => ({ ...prev, members }));
          setCurrentTeamMembers(prev => ({ ...prev, members }));
          setIsDisplayed(prev => ({
            ...prev,
            members: members.length > 0,
          }));
        }
        setNextPageUrl(response.data.nextLink || null)
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      }
      else {
        setIsErrorFetching(true);
        console.error("Error fetching data: ", error);
      }
    } finally {
      isLoadMore ? setIsLoadingMoreMember(false) : setIsLoadingMemberList(false);
    }

  }

  // const fetchTeamMembers = async (id) => {
  //   setIsLoadingMemberList(true);
  //   try {
  //     const response = await getTeamMembers(id);
  //     if (response.status === APIStatus.success) {
  //       const members = response.data.members.filter(user => !user.isOwner);

  //       // Update state with the categorized team members
  //       setTeamMembers({ ...teamMembers.owners, members });
  //       setCurrentTeamMembers({ ...teamMembers.owners, members });

  //       // Set isDisplayed based on the length of owners and members arrays
  //       setIsDisplayed({
  //         ...isDisplayed.owners,
  //         members: members?.length > 0,
  //       });
  //       setNextPageUrl(response.data.nextLink || null)
  //     }
  //     else {
  //       console.error(response.data);
  //       setIsErrorFetching(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     setIsErrorFetching(true);
  //   } finally {
  //     setIsLoadingMemberList(false);
  //   }
  // }

  // const fetchMoreTeamMembers = async (id, nextPageUrl) => {
  //   setIsLoadingMoreMember(true);
  //   try {
  //     const response = await getTeamMembers(id, nextPageUrl);
  //     if (response.status === APIStatus.success) {
  //       const owners = response.data.members.filter(user => user.isOwner);
  //       const members = response.data.members.filter(user => !user.isOwner);

  //       setTeamMembers(prev => ({
  //         owners: [...prev.owners, ...owners],
  //         members: [...prev.members, ...members]
  //       }));

  //       setCurrentTeamMembers(prev => ({
  //         owners: [...prev.owners, ...owners],
  //         members: [...prev.members, ...members]
  //       }));
  //       setNextPageUrl(response.data.nextLink || null)
  //     }
  //     else {
  //       console.error(response.data);
  //       setIsErrorFetching(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     setIsErrorFetching(true);
  //   } finally {
  //     setIsLoadingMoreMember(false);
  //   }
  // }

  useEffect(() => {
    let email = account?.username || ""
    if (!email.includes("@sv1")) {
      fetchSSO();
    }
  }, [account?.username])

  useEffect(() => {
    if (!idTeam) return;
    const controller = new AbortController();
    const { signal } = controller;

    setIsLoadingTeamInfo(true);

    const fetchData = async (idTeam, nextPageUrl) => {
      // Only fetch if teamMembers is empty
      try {
        await Promise.all([
          fetchTeamInfo(idTeam, signal),
          fetchTeamMembers(idTeam, nextPageUrl, false, signal),
        ]);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request cancelled for team:", idTeam);
        } else {
          console.error("Error fetching data:", error);
        }
      } finally {
        if (!signal.aborted) {
          setIsLoadingTeamInfo(false);
        }
      }
    };
    if (idTeam) {
      const url = null;
      setNextPageUrl(url);
      fetchData(idTeam, url);
    }

    return () => {
      controller.abort();
    }
  }, [idTeam]);

  // useEffect(() => {
  //   // Check if idTeam exists in sessionStorage and load it
  //   const storedIdTeam = sessionStorage.getItem('idTeamSelected');
  //   if (storedIdTeam) {
  //     setIdTeam(storedIdTeam);
  //     setIsOpened(false);
  //   }

  //   // Save idTeam in sessionStorage instead of localStorage
  //   return () => {
  //     sessionStorage.removeItem('idTeamSelected'); // Automatically removed when tab is closed
  //   };
  // }, []);

  useEffect(() => {
    if (!idTeam)
      setIsOpened(true)
    else {
      setIsOpened(false);
      setIsErrorFetching(false);
    }
  }, [idTeam])



  if (apiError) {
    return <ErrorPage message="" />;
  }

  return (
    <>
      {isLoadingUser ? (
        <div className="loading-page">
          <ImSpinner9 className="spin-icon" />
        </div>
      ) : (
        <>
          <Header
            userInfo={userInfo}
          />

          {/* Main Content */}
          <div className="main-content">
            {/* Left side */}
            <section className={`left-section ${isOpened ? "active" : ""}`}>
              <ListGroup
                setIsOpened={setIsOpened}
                setIsPopup={() => setIsPopup({ ...isPopup, creatingGroup: true })}
                setIdTeam={setIdTeam}
                idTeamSelected={idTeam}
                setApiError={setApiError}
              />
            </section>
            {/* Right side */}
            <section className="right-section">
              <TeamsManagement
                setIsOpened={setIsOpened}
                idTeamSelected={idTeam}
                setIsPopup={() => setIsPopup({ ...isPopup, addingMember: true })}
                teamInfo={teamInfo}
                teamMembers={teamMembers}
                isDisplayed={isDisplayed}
                setIsDisplayed={setIsDisplayed}
                currentTeamMembers={currentTeamMembers}
                setCurrentTeamMembers={setCurrentTeamMembers}
                isLoading={isLoadingTeamInfo}
                isLoadingMemberList={isLoadingMemberList}
                isErrorFetching={isErrorFetching}
                isOwner={isOwner}
                isLoadingMoreMember={isLoadingMoreMember}
                fetchTeamMembers={() => nextPageUrl ? fetchTeamMembers(idTeam, nextPageUrl, true) : {}}
              />
            </section>
          </div>

          <CreateGroupPopup
            isOpen={isPopup.creatingGroup}
            onClose={() => setIsPopup({ ...isPopup, creatingGroup: false })}
          />

          <AddMemberPopUp
            isOpen={isPopup.addingMember}
            idTeamSelected={idTeam}
            onClose={() => setIsPopup({ ...isPopup, addingMember: false })}
            fetchTeamMembers={() => fetchTeamMembers(idTeam, nextPageUrl, false)}
          />
        </>
      )}
    </>
  );
};